import { render } from "./InvoiceBody.vue?vue&type=template&id=d86ea2ee"
import script from "./InvoiceBody.vue?vue&type=script&lang=js"
export * from "./InvoiceBody.vue?vue&type=script&lang=js"

import "./InvoiceBody.vue?vue&type=style&index=0&id=d86ea2ee&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__